/*  ========================================================================
    # Scripts - Cards
    ========================================================================  */

/**
 * Script that handles the contact dialog.
 */
const Cards = {
  cfg: {
    cards: document.querySelectorAll('.s-cards__item')
  },

  /**
   * Handle accordion triggers.
   */
  handleCards() {
    this.cfg.cards.forEach(item => {
      item.addEventListener('mouseenter', e => {
        this.updateCursorPosition(item, e);
      });

      item.addEventListener('mousemove', e => {
        this.updateCursorPosition(item, e);
      });
    });
  },

  updateCursorPosition(item, event) {
    const rect = item.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    item.style.setProperty('--cursor-x', `${x}%`);
    item.style.setProperty('--cursor-y', `${y}%`);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.cards.length > 0) {
      this.handleCards();
    }
  }
};

export default Cards;
